import { useMemo, useState } from "react";
import PageHeader from "@/components/feature/PageHeader";
import FilterSortBar from "@/components/feature/FilterSortBar";
import ContentCard from "@/components/base/ContentCard";
import EmptyState from "@/components/base/EmptyState";
import { useSEO } from "@/hooks/useSEO";
import { newsItems, newsCategories } from "@/mocks/content";
import { filterItems, sortItems } from "@/utils/content";

const PAGE_SIZE = 5;

export default function News() {
  useSEO({
    title: "最新动态 - 白峰美羽",
    description: "白峰美羽最新活动公告、媒体报道与品牌动态，第一时间了解品牌与新品资讯。",
    keywords: "白峰美羽,最新动态,活动公告,媒体报道,品牌动态",
  });

  const [category, setCategory] = useState("全部");
  const [order, setOrder] = useState<"latest" | "oldest" | "title">("latest");
  const [visible, setVisible] = useState(PAGE_SIZE);

  const filtered = useMemo(() => {
    const items = filterItems(newsItems, category);
    return sortItems(items, order);
  }, [category, order]);

  const current = filtered.slice(0, visible);
  const hasMore = visible < filtered.length;

  const reset = () => {
    setCategory("全部");
    setOrder("latest");
    setVisible(PAGE_SIZE);
  };

  return (
    <>
      <PageHeader
        eyebrow="NEWS CENTER"
        title="最新动态"
        description="涵盖品牌活动公告、媒体报道与新品发布，持续更新白峰美羽的最新消息。"
        crumbs={[{ label: "首页", path: "/" }, { label: "最新动态" }]}
      />

      <section className="max-w-site mx-auto px-4 md:px-6 py-10 md:py-14">
        <FilterSortBar
          categories={newsCategories}
          activeCategory={category}
          onCategoryChange={(c) => {
            setCategory(c);
            setVisible(PAGE_SIZE);
          }}
          sortOrder={order}
          onSortChange={(o) => {
            setOrder(o);
            setVisible(PAGE_SIZE);
          }}
        />

        <div className="mt-8">
          {current.length > 0 ? (
            <div className="flex flex-col gap-5">
              {current.map((item) => (
                <ContentCard key={item.id} item={item} variant="horizontal" />
              ))}
            </div>
          ) : (
            <EmptyState
              title="暂无符合条件的动态"
              description="试试切换筛选分类，或重置筛选条件查看全部内容。"
              onReset={reset}
            />
          )}
        </div>

        {hasMore && (
          <div className="flex justify-center mt-10">
            <button
              type="button"
              onClick={() => setVisible((v) => v + PAGE_SIZE)}
              className="px-7 py-3 rounded-md border border-primary-300 text-primary-600 text-sm font-medium hover:bg-primary-50 transition-colors whitespace-nowrap cursor-pointer"
            >
              加载更多
              <i className="ri-arrow-down-line ml-2"></i>
            </button>
          </div>
        )}
      </section>
    </>
  );
}